import { useAppSelector } from "@/reducers/hooks"
import { selectChatsSettings } from "@/reducers/chatsSliceSelectors"
import { useContext } from "react"
import { XmppContext } from "@/stream/xmppClient"
import { getCMRJid } from "@/jidUtils"
import { BellOff } from "lucide-react"
import { useTranslation } from "react-i18next"

const CMRHeader = () => {
  const { t } = useTranslation()
  const { myJid } = useContext(XmppContext)
  const chatsSettings = useAppSelector(selectChatsSettings)

  const cmrChatJid = getCMRJid(myJid)

  const isCMRMuted = Boolean(chatsSettings[cmrChatJid]?.muted)

  return (
    <div className="flex items-center gap-4">
      <span>{t("chatHeader.cmrDocuments")}</span>
      {isCMRMuted && <BellOff className="h-4 w-4 text-gray-800" />}
    </div>
  )
}

export default CMRHeader
